module.exports = __webpack_public_path__ + "img/bedside-var-02.2f575b2f.png";